// extracted by mini-css-extract-plugin
export default {"item":"Item_item__Rb+dk","head":"Item_head__6gBOc","active":"Item_active__L03oO","body":"Item_body__lq1Zy","title":"Item_title__Z1NAD"};